export default __webpack_public_path__ + "static/media/img-cannabis-mobile.72e796d1.png";